/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.DocumentsSummary = {
  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 44,
    rowHeight: 44,
    columnDefs: null,
    rowData: null,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridReady(event) {
      return event.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    }
  },

  _originalRowNodes: null,

  refreshTableData(tableSelector) {
    const visibleBidders = BiddersUtils.getBidders('visible');
    const originalRows = this._originalRowNodes;
    const visibleRows = [];
    _.each(originalRows, function (node) {
      if (_.includes(visibleBidders, node.data.name)) {
        return visibleRows.push(node.data);
      }
    });
    this._gridApi.setGridOption('rowData', visibleRows);
    return this._gridApi.sizeColumnsToFit();
  },

  _renderInvitationStatus(params) {
    return `<div class='invitation-status ${params.data.state.replace(/ /g, '_')}'>${params.data.state}</div>`;
  },

  _renderBidStatus(params) {
    return `<div class='bid-status ${params.data.bid_state.toLowerCase().replace(/ /g, '_')}'>${params.data.bid_state}</div>`;
  },

  _filterBidders(bidders) {
    const filteredBidders = _.filter(bidders, bidder => (bidder.bid_state !== 'Did not submit') && (bidder.state !== 'revoked') && (bidder.state !== 'opted out'));
    return this._gridApi.setGridOption('rowData', filteredBidders);
  },

  _bidValueComparator(valueA, valueB) {
    const comparableValueA = this._localeStringToFloat(valueA);
    const comparableValueB = this._localeStringToFloat(valueB);

    return comparableValueA - comparableValueB;
  },

  _localeStringToFloat(string) {
    const localeStringNumber = string.split(" ")[1];
    const stringNumberWithoutCommas = localeStringNumber.replace(/,/g, '');
    return parseFloat(stringNumberWithoutCommas);
  },

  initializeTable(tableSelector, params) {
    const data = _.map(params, doc => JSON.parse(doc));
    const locales_path = 'v4.tenders.bidding_analysis.bidding_overview';
    const columnDefs =
      [
        { headerName: I18n.t('bidder'), field: 'name', minWidth: 300, pinned: 'left' },
        {
          headerName: I18n.t('invitation'),
          field: 'invitation',
          width: 70,
          children: [
            { headerName: I18n.t('status'), field: 'state', width: 200, cellRenderer: params => this._renderInvitationStatus(params) },
            { headerName: I18n.t(`${locales_path}.date`), field: 'created_at', width: 200 }
          ]
        },
        {
          headerName: I18n.t('rfcs'),
          field: 'rfcs',
          children: [
            { headerName: I18n.t(`${locales_path}.open`), field: 'opened_rfcs_count', width: 70, suppressSizeToFit: true },
            { headerName: I18n.t(`${locales_path}.closed`), field: 'closed_rfcs_count', width: 70, suppressSizeToFit: true }
          ]
        },
        {
          headerName: I18n.t(`${locales_path}.bids`),
          field: 'bids',
          width: 90,
          children: [
            { headerName: I18n.t('status'), field: 'bid_state', width: 200, cellRenderer: params => this._renderBidStatus(params) },
            { headerName: I18n.t(`${locales_path}.date`), field: 'bid_date', width: 200 },
            { headerName: I18n.t(`${locales_path}.submittals`), field: 'bid_submittals', width: 130 },
            { headerName: `${I18n.t('v4.tenders.bidding_analysis.bidding_overview.coverage')} %`, field: 'bid_coverage', width: 150 },
            { headerName: I18n.t(`${locales_path}.changes`), field: 'bid_changes', width: 130 },
            { headerName: `${I18n.t('v4.tenders.bidding_analysis.bidding_overview.bid_value')}`, field: 'bid_value', cellClass: 'align-right', comparator: _.bind(this._bidValueComparator, this) }
          ]
        },
        {
          headerName: "Evaluation Scores",
          width: 400,
          field: 'bid_score',
          valueFormatter(params) {
            const value = (Math.round(params.value * 100) / 100);
            if (_.isNaN(value)) {
              return params.value;
            } else if (value === 0) {
              return '-';
            } else {
              return value;
            }
          },
          cellClass(params) {
            const value = parseFloat(params.value);
            if (_.isNaN(value)) { return 'super-light-text'; }
            if (value === 0) {
              return '';
            } else if (value < 60) {
              return 'pt-red';
            } else {
              return 'pt-green';
            }
          }
        }
      ];

    this._gridOptions.columnDefs = columnDefs;
    this._gridOptions.rowData = data;
    this._gridOptions.onGridSizeChanged = () => {
      return this._gridApi.sizeColumnsToFit();
    };

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;

    this._originalRowNodes = this._gridApi.getModel().rowsToDisplay;

    this._filterBidders(data);

    return this._gridApi.sizeColumnsToFit();
  }
};
